import ReactDOM from 'react-dom/client';
import { v2Component } from '../../../index';
import { TenantContext } from '../../../context/tenant-context';
import { TaxConfig } from './tax-config';

export function initTaxConfig(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('tax-config');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <TaxConfig {...props} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
